module.exports = __webpack_public_path__ + "img/back.8fc630fa.svg";